<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <!-- eslint-disable max-len -->
    <path
      v-if="blank"
      d="M19,4H18V2H16V4H8V2H6V4H5A2,2,0,0,0,3,6V20a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V6A2,2,0,0,0,19,4Zm0,16H5V9H19Z"
    />
    <path
      v-else
      d="M19,4H18V2H16V4H8V2H6V4H5A2.006,2.006,0,0,0,3,6V20a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V6A2.006,2.006,0,0,0,19,4Zm0,16H5V9H19ZM7,11h5v5H7Z"
    />
    <!-- eslint-enable max-len -->
  </svg>
</template>

<script>
export default {
  name: 'CalendarIcon',
  props: {
    /** 空白のカレンダーを表示します */
    blank: Boolean,
  },
}
</script>
